/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Run_Signal_TitleInputs */

const en_automation_run_signal_title = /** @type {(inputs: Automation_Run_Signal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signal`)
};

const pt_br2_automation_run_signal_title = /** @type {(inputs: Automation_Run_Signal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinal`)
};

/**
* | output |
* | --- |
* | "Signal" |
*
* @param {Automation_Run_Signal_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_run_signal_title = /** @type {((inputs?: Automation_Run_Signal_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Run_Signal_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_run_signal_title(inputs)
	return pt_br2_automation_run_signal_title(inputs)
});